import React, { Component } from 'react'

import urlFor, { QueryParams } from 'shared/tools/url-helper'

import Linka from 'client/shared/blocks/linka'
import comicbookHelper from 'shared/tools/comicbook-helper'
import audiobookHelper from 'shared/tools/audiobook-helper'

import AudioBookCover from 'client/shared/blocks/audiobook-cover'
import { BookCover } from 'client/shared/blocks/book-cover'

import LibraryCardStatusBox from 'client/bookmate/boxes/library-card-status-box'
import BookStatus from 'client/shared/blocks/book-status'

import StoreLinksBox from 'client/shared/boxes/store-links-box'
import BadgeList from 'client/shared/blocks/badge-list'
import Spacer from 'client/shared/blocks/spacer'
import {
  TYPE_BOOK,
  TYPE_SERIAL,
  TYPE_AUDIOBOOK,
  TYPE_COMICBOOK,
} from 'client/shared/types/showcase'
import { BookSerialProps } from 'client/shared/types/resource'
import { AudiobookProps } from 'client/shared/types/audiobook'
import { ComicbookProps } from 'client/shared/types/comicbook'

type Props = {
  isOneColumnSize: boolean
  resource: BookSerialProps | AudiobookProps | ComicbookProps
  isMobileOS?: boolean
  serialInfo?: Record<string, string | number>
  isContentHidden?: boolean
  query?: QueryParams
}

export class ResourceLead extends Component<Props> {
  render(): JSX.Element {
    const { isOneColumnSize, resource, isMobileOS, serialInfo } = this.props
    const { labels = [], language = '', resourceType } = resource
    const isBookSerial =
      resourceType === TYPE_BOOK || resourceType === TYPE_SERIAL

    return (
      <div className={`${resourceType}-info__lead`}>
        {this.getBookStatus(resource)}
        {this.getResourceCover(resource, serialInfo)}
        <Spacer />
        {!isOneColumnSize && (
          <div>
            <Spacer />
            <BadgeList labels={labels} language={language} />
            <Spacer />
          </div>
        )}
        {isBookSerial && !(isOneColumnSize || isMobileOS) && <StoreLinksBox />}
      </div>
    )
  }

  getResourceCover(
    resource: BookSerialProps | AudiobookProps | ComicbookProps,
    serialInfo?: Record<string, string | number>,
  ): JSX.Element {
    switch (resource.resourceType) {
      case TYPE_BOOK:
      case TYPE_SERIAL:
        return resource?.can_be_read && !resource?.restricted_reading_on_web ? (
          <Linka
            path={urlFor.reader(
              resource.uuid,
              {
                resourceType: resource.resourceType,
              },
              { ...serialInfo, ...this.props.query },
            )}
            target="_blank"
          >
            <BookCover
              book={resource}
              size={{
                desktopLarge: 208,
                desktopMedium: 208,
                desktop: 176,
                tablet: 120,
                mobile: 88,
              }}
              isLeadCover
            />
          </Linka>
        ) : (
          <BookCover
            book={resource}
            size={{
              desktopLarge: 208,
              desktopMedium: 208,
              desktop: 176,
              tablet: 120,
              mobile: 88,
            }}
            isLeadCover
          />
        )
      case TYPE_AUDIOBOOK:
        return (
          <AudioBookCover
            audiobook={resource}
            size={{
              desktopLarge: 176,
              desktopMedium: 176,
              desktop: 176,
              tablet: 176,
              mobile: 120,
            }}
            isLeadCover
          />
        )
      case TYPE_COMICBOOK:
        return (
          <BookCover
            book={resource}
            size={{
              desktopLarge: 176,
              desktopMedium: 176,
              desktop: 176,
              tablet: 176,
              mobile: 120,
            }}
            isLeadCover
          />
        )
    }
  }

  getBookStatus(
    resource: BookSerialProps | AudiobookProps | ComicbookProps,
  ): JSX.Element {
    const { isContentHidden } = this.props

    switch (resource.resourceType) {
      case TYPE_BOOK:
      case TYPE_SERIAL:
        return (
          <LibraryCardStatusBox
            resourceType={resource.resourceType}
            isContentHidden={isContentHidden}
          />
        )
      case TYPE_AUDIOBOOK:
        return (
          <BookStatus
            progress={
              audiobookHelper.inProgress(resource)
                ? audiobookHelper.getProgressInPercent(resource)
                : null
            }
            isFinished={audiobookHelper.isFinished(resource)}
            isPrivate={audiobookHelper.isPrivate(resource)}
            isContentHidden={isContentHidden}
          />
        )
      case TYPE_COMICBOOK:
        return (
          <BookStatus
            progress={
              comicbookHelper.inProgress(resource)
                ? comicbookHelper.getProgressInPercent(resource)
                : null
            }
            isFinished={comicbookHelper.isFinished(resource)}
            isPrivate={comicbookHelper.isPrivate(resource)}
            isContentHidden={isContentHidden}
          />
        )
    }
  }
}
